import ServiceMembersPanelContainer from "./ServiceMembersPanel.container"

export default ServiceMembersPanelContainer;